import { login } from "@/entities/session";
import { useAppDispatch, useAppSelector } from "@/app/appStore";
import {
  Box,
  Button,
  Card,
  Flex,
  Heading,
  Text,
  TextField,
} from "@radix-ui/themes";
import ChromeUsageReminder from "@/shared/ui/chrome-usage-reminder";
import { isChrome } from "react-device-detect";
import { useAuthRedirect } from "@/shared/hooks/useAuthRedirect";

export function Login() {
  const dispatch = useAppDispatch();
  const isPending = useAppSelector((state) => state.auth.loading === "pending");
  const { redirectToStoresAfterLogin } = useAuthRedirect();

  return (
    <Box className="flex items-center justify-center w-full h-screen">
      {!isChrome && <ChromeUsageReminder />}
      <Card className="min-w-[300px] max-w-[400px] p-4 shadow-lg" asChild>
        <form
          onSubmit={async (e) => {
            e.preventDefault();

            const formData = new FormData(e.target as HTMLFormElement);

            const username = formData.get("username");
            const password = formData.get("password");

            dispatch(login({ username, password }))
              .unwrap()
              .then(() => {
                redirectToStoresAfterLogin();
              });
          }}
        >
          <Heading mb="4">Sign In</Heading>
          <Text weight="medium" className="mb-2" size="1" asChild>
            <label htmlFor="username">Username</label>
          </Text>
          <TextField.Root
            className="mb-3"
            id="username"
            name="username"
            placeholder="Enter username"
          ></TextField.Root>
          <Text weight="medium" className="mb-2" size="1" asChild>
            <label htmlFor="password">Password</label>
          </Text>
          <TextField.Root
            className="mb-3"
            id="password"
            name="password"
            type="password"
            placeholder="Enter password"
          ></TextField.Root>

          <Flex justify="end">
            <Button loading={isPending} type="submit">
              Sign in
            </Button>
          </Flex>
        </form>
      </Card>
    </Box>
  );
}
